import React, {Component, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Picker } from 'emoji-mart';
import { Paper, Button, TextField, Tabs } from 'components'
import { FileInput } from 'features'

import * as actionCreators from 'store/actions'
import classes from './IconInput.module.css'
import './EmojiPicker.css'

const tabStyles = {
    main: {
        backgroundColor: 'var(--secondary-color)',
        margin: 0
    },
    tab: {
        width: '4rem',
        // backgroundColor: 'var(--secondary-color)'
    }
}

const IconInput = props => {
    const {
        onClose,
        closeHandler,
        onSubmit,
        theme
    } = props;
    const tabOptions = {
        link: 'Link',
        file: 'File',
        emoji: 'Emoji',
    }

    const [tab, setTab] = useState('link')
    const [value, setValue] = useState(null)

    const onSelectEmojiHandler = (emoji) => {
        onSubmit(emoji, tab)
        closeHandler && closeHandler()
    }

    const onSubmitLinkHandler = (link) => {
        onSubmit(link || value, tab)
        // onSubmit(link || value, tab)
        closeHandler && closeHandler()
    }

    const onRemoveHandler = () => {
        onSubmit(null, null)
        closeHandler && closeHandler()
    }

    const keypressHandler = (event) => {
        // Enter
        if (event.charCode === 13) {
            if(!value ? false : value.length > 0){
                onSubmit(value, tab)
                closeHandler && closeHandler()
            }
        } 
        else if (event.keyCode === 27 ) {
            setValue(null)
            closeHandler && closeHandler()
        } 
    }

    let selector = null;
    if(tab === 'emoji') {
        selector = <Picker native={true} autoFocus={true} style={{width:'100%'}}
                        emoji='' title='' showSkinTones={false} showPreview={false} 
                        theme={theme === 'Light' ? 'light' : 'dark'}
                        onClick={onSelectEmojiHandler}
                        exclude={['flags','symbols']}/>
    } else if (tab === 'link') {
        selector = <div className={classes.LinkInput}>
                        <div className={classes.TextContainer}>
                            <TextField type='single' onChange={(event) => setValue(event.target.value)} value={value} placeholder='Paste an image link'
                                onKeyPress={keypressHandler} onKeyDown={keypressHandler}/>
                        </div>
                        <div className={classes.ButtonsContainer}>
                            <Button valid={!value ? false : value.length > 0 ? true : false} text='Submit' onSelect={(event) => onSubmitLinkHandler()}
                                disable={!value ? false : value.length === 0} styles={{backgroundColor: 'var(--focus-color)', color: 'white', margin: 0, fontWeight: 'bolder'}}/>
                        </div>
                    </div>   
    } 
    else if (tab === 'file'){
        selector = <div className={classes.FileInput}><FileInput onSubmit={onSubmitLinkHandler} placeholder='Drop your image here' fileWarnings='Only image files allowed'/></div>
    }
    return (
        <Paper>
            <div className={classes.IconInput}>
                <div className={classes.Header}>
                    <Tabs styles={tabStyles} options={tabOptions} selected={tab} onSelect={setTab}/>
                    <Button text='Remove' onSelect={onRemoveHandler} styles={{backgroundColor: 'var(--secondary-color)', boxShadowColor: 'transparent',fontWeight: 'bolder', margin: 0}}/>
                </div>
                {selector}
            </div>
        </Paper>
    )
}

export default IconInput;

IconInput.propTypes = {
    closeHandler: PropTypes.func,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}